module.exports = __webpack_public_path__ + "img/timsit.c81d9d3a.jpg";